/*******************************************************************************

  Project: SWISSAA
  Author:  WHAT.DIGITAL
  Date:    MARCH 2021

********************************************************************************/

jQuery(document).ready(function ($) {
  //GDPR
  $(".cookie .btns a").click(function () {
    $(".cookie").addClass("hide-cookie");
    return false;
  });

  const cookieBox = document.getElementById("js-cookie-box");
  const cookieButton = document.getElementsByClassName("js-cookie-button");
  if (!Cookies.get("cookie-box")) {
    cookieBox.classList.remove("hide-cookie");
    cookieButton.onclick = function () {
      Cookies.set("cookie-box", true, { expires: 30 });
      cookieBox.classList.add("hide-cookie");
    };
  }

  //HAMBURGER
  $(".hamburger").click(function () {
    $("body").toggleClass("nav-act");
  });

  $(".hamburger-box").click(function (e) {
    e.preventDefault;
    console.log($(this).parent().closest(".container"));
    $("#submenu .container").toggleClass("active");
    $(this).parent().toggleClass("active");
  });

  // Media Query to handle the drop-downs on Menu
  const mediaQuery = window.matchMedia("(max-width: 992px)");
  function handleMediaQueryChange(event) {
    if (event.matches) {
      $('.megamenu [class*="col-"] ul li:first-child').on(
        "click",
        function (e) {
          e.preventDefault();
          $('.megamenu [class*="col-"] ul').removeClass("act");
          $(this).toggleClass("active");
          if ($(this).hasClass("active")) {
            $(this).parent().addClass("act");
          } else {
            $('.megamenu [class*="col-"] ul').removeClass("act");
          }
        }
      );
    }
  }

  mediaQuery.addEventListener("change", handleMediaQueryChange);

  handleMediaQueryChange(mediaQuery);

  $(".side-contact span").click(function () {
    $(this).parent().find("ul").slideToggle();
  });

  $(document).ready(function () {
    $("div.search button").click(function () {
      $(".search").toggleClass("act");
    });
  });

  $(".testimonial-carousel").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  $(".popup-modal").magnificPopup({
    type: "inline",
    preloader: false,
    modal: true,
  });

  $(document).on("click", ".popup-modal-dismiss", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  $(".popup-modal-register").magnificPopup({
    type: "inline",
    preloader: false,
    modal: true,

    callbacks: {
      open: function () {
        let activePopup = $.magnificPopup.instance.currItem.src;
        history.pushState(null, null, activePopup);
      },
      close: function () {
        history.pushState(
          "",
          document.title,
          window.location.pathname + window.location.search
        );
      },
    },
  });

  // Opening a popup from a URL
  let hash = window.location.hash;
  if (hash) {
    let popupLink = $('.popup-modal-register[href="' + hash + '"]');
    if (popupLink.length) {
      popupLink.click();
    }
  }
});

(function ($) {
  $(document).on("click", ".misha_loadmore", function () {
    var offset = $(this).data("offset");
    var limit = $(this).data("limit");
    var posts = $(this).data("post");
    var order = $(this).data("order");

    var button = $(this),
      data = {
        action: "loadmore",
        offset: offset,
        limit: limit,
        post: posts,
        order: order,
      };

    $.ajax({
      // you can also use $.post here
      url: theme_settings.ajaxurl, // AJAX handler
      data: data,
      type: "POST",
      dataType: "JSON",
      beforeSend: function (xhr) {
        button.text("Loading..."); // change the button text, you can also add a preloader image
      },
      success: function (content) {
        if (content.output) {
          $(".load-more-posts").before(content.output); // insert new posts

          if (content.btn) {
            $(".misha_loadmore").replaceWith(
              '<span class="misha_loadmore button-red d-table mx-auto" data-offset="' +
                content.offset +
                '" data-limit="' +
                content.limit +
                '" data-post="' +
                content.post +
                '">Load more</span>'
            );
          } else {
            button.remove(); // if no data, remove the button as well
          }
        } else {
          button.remove(); // if no data, remove the button as well
        }
      },
    });
  });

  $(document).on("click", ".ascending", function () {
    var limit = $(this).data("post-limit");
    var posts = $(this).data("post");

    var button = $(this),
      data = {
        action: "loadmore_by_order",
        order: "ASC",
        limit: limit,
        post: posts,
      };

    $.ajax({
      // you can also use $.post here
      url: theme_settings.ajaxurl, // AJAX handler
      data: data,
      type: "POST",
      dataType: "JSON",
      success: function (content) {
        if (content.output) {
          $(".ajax-content").html(content.output); // insert new posts

          if (content.btn) {
            $(".load-more").replaceWith(
              '<div class="col-lg-9 load-more ml-auto"><span class="misha_loadmore button-red d-table mx-auto" data-offset="' +
                content.offset +
                '" data-limit="' +
                content.limit +
                '" data-post="' +
                content.post +
                '" data-order="ASC">Load more</span></div>'
            );
          } else {
            button.remove(); // if no data, remove the button as well
          }
        } else {
          button.remove(); // if no data, remove the button as well
        }
      },
    });
  });

  $(document).on("click", ".descending", function () {
    var limit = $(this).data("post-limit");
    var posts = $(this).data("post");

    var button = $(this),
      data = {
        action: "loadmore_by_order",
        order: "DESC",
        limit: limit,
        post: posts,
      };

    $.ajax({
      // you can also use $.post here
      url: theme_settings.ajaxurl, // AJAX handler
      data: data,
      type: "POST",
      dataType: "JSON",
      success: function (content) {
        if (content.output) {
          $(".ajax-content").html(content.output); // insert new posts

          if (content.btn) {
            $(".load-more").replaceWith(
              '<div class="col-lg-9 ml-auto load-more"><span class="misha_loadmore button-red d-table mx-auto" data-offset="' +
                content.offset +
                '" data-limit="' +
                content.limit +
                '" data-post="' +
                content.post +
                '" data-order="DESC">Load more</span></div>'
            );
          } else {
            button.remove(); // if no data, remove the button as well
          }
        } else {
          button.remove(); // if no data, remove the button as well
        }
      },
    });
  });

  $(".megamenu [class*=col-] ul li.active-link")
    .parent()
    .find("li:first-child")
    .addClass("active-link");

  //Open megamenu on click on Left Button on Submenu
  // ---------------------------------------------
  $("#header-submenu-button").click(function () {
    $(this).toggleClass("active");
    $(".megamenu").toggleClass("active"); // Toggle class and slide toggle
    $(".header-submenu").toggleClass("active");
    event.stopPropagation();
  });

  $(document).click(function (event) {
    // Check if the clicked element is not .megamenu or a child of .megamenu
    if (!$(event.target).closest(".megamenu").length) {
      // If so, remove the "active" class from #header-submenu-button and .megamenu
      $("#header-submenu-button").removeClass("active");
      $(".megamenu").removeClass("active"); // Remove class and slide up
      $(".header-submenu").removeClass("active");
    }
  });

  //Event Swiper
  // ---------------------------------------------
  var swiperDays = new Swiper(".js-calendar-date", {
    autoHeight: true,
    slidesPerView: 1,
    allowTouchMove: false,
    navigation: {
      nextEl: ".days-button-next",
      prevEl: ".days-button-prev",
    },
    on: {
      //if change slide in swiperDays, change slide in swiperTimeline
      slideChange: function () {
        var index = this.activeIndex;
        swiperTimeline[0].slideTo(index);
        $(".js-calendar-panel__el")
          .eq(index)
          .addClass("active")
          .siblings()
          .removeClass("active");
        centerActiveElement();
      },
    },
  });

  var swiperTimeline = new Swiper(".js-calendar-timeline", {
    autoHeight: true,
    slidesPerView: 1,
    allowTouchMove: false,
  });

  // Function to center the active element in the js-calendar-panel
  function centerActiveElement() {
    var panel = $(".js-calendar-panel");
    var activeElement = $(".js-calendar-panel__el.active");

    if (panel.length > 0 && activeElement.length > 0) {
      var panelWidth = panel.width();
      var activeElementWidth = activeElement.width();
      var activeElementPosition = activeElement.position().left;
      var scrollLeft =
        activeElementPosition + activeElementWidth / 2 - panelWidth / 2;

      panel.animate({ scrollLeft: scrollLeft }, 500); // You can adjust the animation duration as needed
    }
  }

  //if click on js-calendar-panel__el take data-index and change slide in swiperTimeline
  $(".js-calendar-panel__el").on("click", function () {
    var days = $(this).closest(".js-calendar-panel").data("index-days");
    var index = $(this).data("index");
    swiperTimeline[days].slideTo(index);
    $(this).addClass("active").siblings().removeClass("active");
    centerActiveElement();
  });

  //if click js-calendar-panel-next take data-index from js-calendar-panel__el with class active and change slide in swiperTimeline to next
  $(".js-calendar-panel-next").on("click", function () {
    var index = $(".js-calendar-panel__el.active").data("index");
    swiperTimeline[0].slideTo(index + 1);
    $(".js-calendar-panel__el.active")
      .next()
      .addClass("active")
      .siblings()
      .removeClass("active");
    centerActiveElement();
  });

  //if click js-calendar-panel-prev take data-index from js-calendar-panel__el with class active and change slide in swiperTimeline to prev
  $(".js-calendar-panel-prev").on("click", function () {
    var index = $(".js-calendar-panel__el.active").data("index");
    swiperTimeline[0].slideTo(index - 1);
    $(".js-calendar-panel__el.active")
      .prev()
      .addClass("active")
      .siblings()
      .removeClass("active");
    centerActiveElement();
  });

  // MatchHeight
  // ---------------------------------------------
  $(".logo-section__large-sponsor-logo").matchHeight();
  $(".logo-section__large-sponsor-name").matchHeight();
  $(".logo-section__large-sponsor-details").matchHeight();
  $(".logo-section__medium-sponsor-logo").matchHeight();
  $(".logo-section__medium-sponsor-name").matchHeight();
  $(".logo-section__medium-sponsor-details").matchHeight();
  $(".logo-section__small-sponsor-logo").matchHeight();
  $(".logo-section__small-sponsor-name").matchHeight();
  $(".logo-section__small-sponsor-details").matchHeight();

  //Google Maps ACF
  // ---------------------------------------------
  function initMap($el) {
    // Find marker elements within the map.
    var $markers = $el.find(".marker");

    // Create a generic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 11,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: "administrative",
          elementType: "all",
          stylers: [
            {
              saturation: "-100",
            },
          ],
        },
        {
          featureType: "administrative.province",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 65,
            },
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: "50",
            },
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: "-100",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "all",
          stylers: [
            {
              lightness: "30",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "all",
          stylers: [
            {
              lightness: "40",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              hue: "#ffff00",
            },
            {
              lightness: -25,
            },
            {
              saturation: -97,
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [
            {
              lightness: -25,
            },
            {
              saturation: -100,
            },
          ],
        },
      ],
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add custom markers.
    map.markers = [];
    $markers.each(function (index) {
      initMarker($(this), map, index);
    });

    // Center the map based on custom markers.
    centerMap(map);

    // Return the map instance.
    return map;
  }

  function initMarker($marker, map, index) {
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create a custom marker using an SVG icon.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: {
        path: "M31.9996 29.5016C28.4636 29.5016 25.5996 26.6376 25.5996 23.1016C25.5996 19.5656 28.4636 16.7016 31.9996 16.7016C35.5356 16.7016 38.3996 19.5656 38.3996 23.1016C38.3996 26.6376 35.5356 29.5016 31.9996 29.5016ZM31.9996 0C19.6284 0 9.59961 10.0288 9.59961 22.4C9.59961 34.7712 31.9996 64 31.9996 64C31.9996 64 54.3996 34.7712 54.3996 22.4C54.3996 10.0288 44.3708 0 31.9996 0Z",
        fillColor: "#FF0000",
        fillOpacity: 1,
        anchor: new google.maps.Point(0, 0),
        strokeWeight: 0,
        scale: 1,
      },
      title: "marker-" + (index + 1),
    });

    map.markers.push(marker);
  }

  function centerMap(map) {
    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      var latlng;
      if (window.innerWidth < 998) {
        latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );
      } else if (window.innerWidth < 1100) {
        latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng() - 0.02
        );
      } else {
        latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng() - 0.035
        );
      }

      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(14);
    } else {
      // fit to bounds
      map.setCenter(bounds.getCenter());
      map.setZoom(14);
    }
  }

  // Render maps on page load.
  $(".acf-map").each(function () {
    var map = initMap($(this));

    google.maps.event.addListenerOnce(map, "tilesloaded", function () {
      $(".acf-map")
        .find("[aria-label^='marker-']")
        .each(function (index, element) {
          var label = $(element).attr("aria-label");
          var markerClass = "marker-" + label.split("-")[1];
          $(element).addClass(markerClass);

          $("." + markerClass).click(function () {
            $(".acf-map").find(".active").removeClass("active");
            $(".map-section__popup").find(".active").removeClass("active");
            $("." + markerClass).addClass("active");

            var activeTop = $(".map-section__popup")
              .find(".active")
              .offset().top;
            var activeHeight = $(".map-section__popup")
              .find(".active")
              .height();
            var popupHeight = $(".map-section__popup").height();
            var popupScroll = $(".map-section__popup").scrollTop();
            var popupCenter = popupHeight / 2;
            var activeCenter = activeTop - popupScroll + activeHeight / 2;
            var scrollTo = activeCenter - popupCenter;
            $(".map-section__popup").animate(
              {
                scrollTop: scrollTo,
              },
              500
            );
          });
        });
    });
  });

  function setCookieForPopup(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookieForPopup(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  setTimeout(function () {
    const now = new Date();
    let start = new Date();
    let end = new Date();
    end.setFullYear(end.getFullYear() + 10); // Add 10 years to the current date

    const startPopup = document.querySelector("[data-start-popup]");
    const endPopup = document.querySelector("[data-end-popup]");

    if (startPopup && startPopup.getAttribute("data-start-popup")) {
      start = new Date(startPopup.getAttribute("data-start-popup"));
    }

    if (endPopup && endPopup.getAttribute("data-end-popup")) {
      end = new Date(endPopup.getAttribute("data-end-popup"));
    }

    if (now >= start && now <= end) {
      // Check if the cookies for popupClosed or formSubmitted do not exist
      if (
        !getCookieForPopup("popupClosed") &&
        !getCookieForPopup("formSubmitted")
      ) {
        // Open the popup only once
        setCookieForPopup("popupClosed", "true", 365);
        if ($("#exit-popup").length) {
          $.magnificPopup.open({
            items: {
              src: "#exit-popup", // Source of the popup content
            },
            type: "inline",
            removalDelay: 500,
            callbacks: {
              beforeOpen: function () {
                // Add class for popup animation
                this.st.mainClass = "mfp-zoom-in";
                setCookieForPopup("popupClosed", "true", 365);
              },
              close: function () {
                // Set the cookie when the popup is actually closed
                setCookieForPopup("popupClosed", "true", 365);
              },
            },
            midClick: true,
            showCloseBtn: false,
            fixedBgPos: true,
            fixedContentPos: true,
            closeOnBgClick: false, // Prevent closing on background click
          });
        }
      }
    }
  }, 10000); // 10 seconds delay

  // On click event handler for the popup dismiss button
  $(document).on("click", ".js-popup-modal-dismiss", function (e) {
    e.preventDefault();
    // Close the popup
    $.magnificPopup.close();
    // Set the cookie for popupClosed
    setCookieForPopup("popupClosed", "true", 365);
  });

  // Event handler for form submission
  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      if ("12907" == event.detail.contactFormId) {
        // Set the cookie for formSubmitted
        setCookieForPopup("formSubmitted", "true", 365);
      }
    },
    false
  );

  // Match Height for speakers and timeline at events page
  function refreshTimelineHeight() {
    var speakersColumn = $(".speakers__column");
    var scrollOverlay = $(".scroll--overlay");

    // Check if the speakers__column element exists
    if (speakersColumn.length) {
      // Check screen width
      if ($(window).width() >= 768) {
        var maxHeight = 0;

        // Iterate over timeline elements and find the maximum height
        $(".js-calendar-timeline").each(function () {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
        });

        // Check if .speakers__wrap is higher than the tallest timeline element
        var speakersWrapHeight = $(".speakers__wrap").height();

        if (speakersWrapHeight > maxHeight) {
          // Set the highest height to the .speakers__wrap
          // Add height of js-calendar-panel and calendar__day
          maxHeight =
            maxHeight +
            $(".js-calendar-panel").height() +
            $(".calendar__day").height();

          $(".speakers__wrap").height(maxHeight);
          speakersColumn.height(maxHeight - 61);
          speakersColumn.addClass("speakers__column--scroll");
        } else {
          // Reset heights and remove speakers__column--scroll class
          $(".speakers__wrap, .speakers__column").css("height", "");
          speakersColumn.removeClass("speakers__column--scroll");
        }

        function updateOverlay() {
          // Check if speakers__column--scroll exists before accessing properties
          if ($(".speakers__column--scroll").length) {
            var isScrolledToBottom =
              Math.abs(
                $(".speakers__column--scroll")[0].scrollHeight -
                  $(".speakers__column--scroll").scrollTop() -
                  $(".speakers__column--scroll").outerHeight()
              ) < 1;
            var isScrollBarActive =
              $(".speakers__column--scroll")[0].scrollHeight >
              $(".speakers__column--scroll").outerHeight();

            if (isScrolledToBottom && isScrollBarActive) {
              scrollOverlay.css("opacity", 0);
            } else {
              scrollOverlay.css("opacity", isScrollBarActive ? 1 : 0);
            }
          }
        }

        // Initial state
        updateOverlay();

        // Update on scroll
        $(".speakers__column--scroll").scroll(updateOverlay);
      } else {
        // If window width is less than 768px, set height to auto for speakers__wrap
        $(".speakers__wrap, .speakers__column").css("height", "auto");

        // Remove class speakers__column--scroll
        speakersColumn.removeClass("speakers__column--scroll");

        // Set opacity to 0 for scroll--overlay
        scrollOverlay.css("opacity", 0);
      }
    }
  }

  // Execute when on page is class calendar__grid
  if ($(".calendar__grid").length) {
    // Refresh timeline height on window resize
    $(window).on("resize", refreshTimelineHeight);

    // Initial height refresh
    refreshTimelineHeight();
  }
})(jQuery);
